<i18n>
{
	"no": {
		"transmissionsFound": "Utgående ediforsendelser funnet: {count}",
		"edipartName": "Edipart",
		"messageType": "Meldingstype",
		"messageFormat": "Meldingsformat",
		"createDate" : "Opprettelsesdato",
		"noOfOrders" : "Antall ordrer",
		"transportMethod" : "Transport metode",
		"sentDate" : "Sendingsdato",
		"errors" : "Feilmeldinger",
		"noOutboundEdiFound": "Ingen EDI funnet",
		"status": "Status"
	},
	"en": {
		"transmissionsFound": "Outbound transmissions found: {count}",
		"edipartName": "Edipart",
		"messageType": "Messagetype",
		"messageFormat": "Messageformat",
		"createDate" : "Date of creation",
		"noOfOrders" : "Number of orders",
		"sentDate" : "Sendingsdato",
		"transportMethod": "Transport method",
		"errors" : "Errors",
		"noOutboundEdiFound": "No EDI found",
		"status": "Status"
	}
}
</i18n>

<template>
	<t-vertical-panel class="edi-list">
		<div slot="header" class="edi-list-header">
			<t-panel-header size="md" type="bp" icon="envelope">
				{{ $tc('transmissionsFound', transmissionsFound) }}
			</t-panel-header>
		</div>
		<div class="edi-list-content">
			<t-grid
				v-if="transmissionsFound !== 0"
				ref="outboundEdiGrid"
				:key="'outboundEdiKey'"
				:columnDefinitions="columnDefinitions"
				:defaultColumnDefinition="defaultColumnDefinition"
				:rowHeight="50"
				:items="getOutboundTransmissions"
				@rowDoubleClick="inspectMessage"
			>
				<template v-slot:status="{ item }">
					<t-timpex-icon
						v-if="item.sentdate"
						:icon="'tick'"
						:color="'green'"
						:type="'bp'"
					/>
					<t-timpex-icon
						v-else
						:icon="'time'"
						:type="'bp'"
					/>
				</template>
			</t-grid>
			<t-no-content-panel v-else :text="$tc('noOutboundEdiFound')" icon="orders" />
		</div>

		<inspectOutboundTransmissionDialog :isShown="showDetails" @close="onClose"/>
	</t-vertical-panel>
</template>

<script>

import Grid  from '@/components/evergreen/timpex/grid/TGrid';
import { mapActions } from './inspection/outbound/store/outbound.store';
import { mapGetters } from './store/edi.store';
import InspectOutboundTransmissionDialog from './inspection/outbound/InspectOutboundTransmissionDialog.vue';

import moment from 'moment';

export default {
	components: { TGrid: Grid, InspectOutboundTransmissionDialog },
	data() {
		return {
			defaultColumnDefinition: { resizable: true },
			rowsSelected: 0,
			showDetails: false,
		};
	},

	computed: {
		...mapGetters(['getOutboundTransmissions']),
		columnDefinitions() {
			return [
				{
					field: 'status',
					displayName: this.$t('status'),
					valueGetter: item => item.sentdate,
					width: 60,
					resizable: false,
				},
				{
					field: 'edipartname',
					displayName: this.$t('edipartName'),
					width: 150
				},
				{
					field: 'messagetypedescription',
					displayName: this.$t('messageType'),
					width: 150
				},
				{
					field: 'messageformatdescription',
					displayName: this.$t('messageFormat'),
					width: 150
				},
				{
					field: 'transportmethoddescription',
					displayName: this.$t('transportMethod'),
					width: 150
				},
				{
					field: 'nooforders',
					displayName: this.$t('noOfOrders'),
					width: 150
				},
				{
					field: 'createdate',
					displayName: this.$t('createDate'),
					valueGetter: item => moment(item.createdate, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss'),
					width: 150
				},
				{
					field: 'sentdate',
					displayName: this.$t('sentDate'),
					valueGetter: item => item.sentdate ?  moment(item.sentdate, 'YYYYMMDDHHmmss').format('YYYY-MM-DD HH:mm:ss') : '',
					width: 150
				},
			];
		},
		transmissionsFound() {
			return this.getOutboundTransmissions.length;
		},
	},

	methods: {
		...mapActions(['inspectOutboundTransmission']),
		onClose() {
			this.showDetails = false;
		},
		async inspectMessage(id) {
			await this.inspectOutboundTransmission(id);
			this.showDetails = true;
		},
	}
	
	
};
</script>

<style lang="scss" scoped>

.edi-list{
	.edi-list-header{
		display:flex;
		height:100%;
		align-items: center;
		padding-left: 15px;
	}

	.edi-list-content{
		height:100%;
		display:flex;
		align-items: center;
		justify-content: center;
		padding: 0 5px;
	}
}

</style>